import React from 'react';
import { throttle } from 'underscore';

import { getScrollParent } from 'common/lib/dom/get-scroll-parent';

interface ScrolledPastWatcherProps {
  setScrolledPast: (isScrolledPast: boolean) => void;
}

export class ScrolledPastWatcher extends React.Component<
  ScrolledPastWatcherProps
> {
  el?: HTMLElement;
  scrollContainer?: HTMLElement | Window;
  scrollContainerTop?: number;
  isScrolledPast?: boolean;

  scrollHandler = throttle(() => {
    if (
      this.el &&
      this.scrollContainer &&
      this.scrollContainerTop !== undefined
    ) {
      const rect = this.el.getBoundingClientRect();
      const isScrolledPast = rect.bottom < this.scrollContainerTop;

      if (isScrolledPast !== this.isScrolledPast) {
        this.isScrolledPast = isScrolledPast;
        this.props.setScrolledPast(isScrolledPast);
      }
    }
  }, 100);

  setRef = (el: HTMLElement | null) => {
    if (el) {
      this.el = el;
      this.scrollContainer = getScrollParent(this.el);
      this.scrollContainerTop =
        this.scrollContainer instanceof Window
          ? 0
          : this.scrollContainer.getBoundingClientRect().top;
      this.scrollContainer.addEventListener('scroll', this.scrollHandler);
      this.scrollHandler();
    } else if (this.scrollContainer) {
      this.scrollContainer.removeEventListener('scroll', this.scrollHandler);
      delete this.el;
      delete this.scrollContainer;
      delete this.scrollContainerTop;
      this.props.setScrolledPast(false);
    }
  };

  render() {
    return <div ref={this.setRef} children={this.props.children} />;
  }
}



// WEBPACK FOOTER //
// ./app/common/components/scrolled-past-watcher.tsx